$.fn.formcreator = function () {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this;

    // Sortable
    $('.formcreator-container').sortable({
        handle: '.handle',
        cursor: 'pointer', //change the cursor when dragging
        appendTo: '.formcreator-container', //When dropped the images need to be appended to the image gallery where they are dropped
        containment: '.formcreator-container', //Make sure the user can't drag the images outside the widget
        revert: true, // if the user releases the image ouside the dropbox it'll return to it's original position
        zIndex: 9999,
        tolerance: 'pointer',

        update: function () {
            var indexes = [];

            $('.formcreator-order').each(function() {
                indexes.push($(this).data('index'));
            });


            // var form = $('<form>').attr({
            //     method: 'post'
            // });
            // form.append($('<input>').attr({
            //     name: 'sort',
            //     value: 1
            // }));
            // form.append($('<input>').attr({
            //     name: 'indexes',
            //     value: indexes.join()
            // }));
            //
            // form.submit();

            $.post('', {
                ajax: 1,
                sort: 1,
                indexes: indexes.join()
            }, function(res) {
                if(res == 1)
                {
                    // RECACULATE INDEXES
                    var index = 0;
                    $('.formcreator-order').each(function() {
                        $(this).attr('data-index', index);
                        $(this).data('index', index);
                        $(this).find('input').data('index', index);
                        console.log(index);
                        index++;
                    });
                }
                else
                {
                    console.log('Error!');
                }
            });
        }
    });

    // Edit
    $('.formcreator .icon.edit').on('click', function () {
        var index = $(this).closest('.formcreator-order').data('index');

        var form = $('<form id="formcreator-edit-field">').attr({
            method: 'post'
        });
        form.append($('<input>').attr({
            name: 'update',
            value: 1
        }));
        form.append($('<input>').attr({
            name: 'index',
            value: index
        }));

        $('body').prepend(form);
        $('#formcreator-edit-field').submit();

    });

    // Delete
    $('.delete').on('click', function () {
        var _this = $(this);
        $('#confirmation-modal').modal({
            onShow: function() {
                /*
                 Hack for bad positioning
                 */
                setTimeout(function () {
                    $('#confirmation-modal').modal('refresh');
                }, 1);
            },
            onApprove: function() {
                var form = $('<form id="formcreator-delete-field">').attr({
                    method: 'post',
                    action: window.location.href
                });

                form.append($('<input>').attr({
                    name: 'delete',
                    value: 1
                }));

                form.append($('<input>').attr({
                    name: 'name',
                    value: _this.data('name')
                }));

                $('body').prepend(form);

                $('#formcreator-delete-field').submit();

            }
        }).modal('show');
    });


    // Form creator dropdown add
    $('.formcreator.dropdown-add').on('click', function () {

        var closestOptionsContainer = $(this).parent().parent().find('.dropdown-options');


        var first = closestOptionsContainer.children().first().clone();

        $(first).find('input[type="text"]').val('');

        closestOptionsContainer.append(first);

    });

};